/* WMD slab picker + leg selector.
 *
 * Deliberately NOT an edit to Prestige's snippets, so theme updates stay clean.
 * All user-facing strings come from the locale-branched JSON config that
 * snippets/wmd-slab-config.liquid prints — Liquid is the single source of truth,
 * never a hardcoded string in here.
 *
 * Notes for whoever touches this next:
 *   - Prestige renders TWO direct children per option value (an sr-only <input>
 *     and the <label>), so never count or select by child index.
 *   - Prestige also renders those thumbnails at a maximum of 136px wide
 *     (widths: '48,68,96,136' in snippets/option-value.liquid). Blown up to a real
 *     tile they look soft, so upgradeThumb() re-requests them from the Shopify CDN
 *     at a usable width. Without it, bigger tiles just means blurrier tiles.
 *   - <product-rerender> replaces the whole .product-info subtree on every variant
 *     change, so the observer watches the document, not the picker.
 *   - If the JSON config fails to parse, the whole picker used to fail SILENTLY.
 *     It now says so once in the console. Do not remove that message.
 */
(function () {
  var DESKTOP_BREAKPOINT = 1000;
  var THUMB_WIDTH = 500;
  var busy = false;
  var pending = false;
  var suppress = false;
  var warned = false;
  var seq = 0;

  function config() {
    var el = document.getElementById('wmd-slab-picker-config');

    if (!el) {
      if (!warned) {
        warned = true;
        console.error('[wmd-slab-picker] config script tag missing — picker inactive.');
      }
      return null;
    }

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      if (!warned) {
        warned = true;
        console.error('[wmd-slab-picker] config JSON is invalid — picker inactive.', e);
      }
      return null;
    }
  }

  function visibleCap() {
    return window.innerWidth >= DESKTOP_BREAKPOINT ? 8 : 6;
  }

  /* Re-request a Shopify CDN image at a width that suits the rendered tile. */
  function upgradeThumb(img, width) {
    if (!img) return;
    if (img.dataset.wmdThumb === String(width)) return;

    var src = img.getAttribute('src') || img.currentSrc || '';
    if (!src || src.indexOf('cdn.shopify.com') === -1) return;

    var next;

    if (/[?&]width=\d+/.test(src)) {
      next = src.replace(/([?&])width=\d+/, '$1width=' + width);
    } else {
      next = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    /* srcset/sizes were written for a 48–136px thumbnail and would win over src. */
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('src', next);
    img.dataset.wmdThumb = String(width);
  }

  /* The leg-bundle script rewrites the picker legend to "Tabletop:" / "Plateau:"
     on EN and FR, so match against every name the option can carry. */
  function findGrid(root, names) {
    if (!names || !names.length) return null;

    var wanted = names.map(function (n) {
      return String(n).trim().toLowerCase();
    });

    var fieldsets = root.querySelectorAll('.variant-picker__option');

    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;

      var text = legend.textContent.replace(/:/g, '').trim().toLowerCase();
      if (wanted.indexOf(text) !== -1) {
        return fieldsets[i].querySelector('.variant-picker__option-values');
      }
    }

    return null;
  }

  function collectTiles(grid) {
    var out = [];
    var pendingInput = null;
    var kids = grid.children;

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];

      if (el.tagName === 'INPUT') {
        pendingInput = el;
        continue;
      }

      if (el.tagName === 'LABEL' || el.tagName === 'A') {
        out.push({ el: el, input: pendingInput });
        pendingInput = null;
      }
    }

    return out;
  }

  function tileName(tile) {
    var sr = tile.el.querySelector('.sr-only');
    return sr ? sr.textContent.trim() : '';
  }

  function decorate(tile, cfg) {
    tile.el.classList.add('wmd-slab-tile');

    upgradeThumb(tile.el.querySelector('img'), THUMB_WIDTH);

    var name = tileName(tile);
    var soldOut = !!(tile.input && tile.input.disabled);
    var price = '';

    if (tile.input && cfg.prices) {
      price = cfg.prices[tile.input.value] || '';
    }

    if (soldOut) {
      tile.el.classList.add('is-disabled');
      price = cfg.soldOut || price;
    } else {
      tile.el.classList.remove('is-disabled');
    }

    var caption = tile.el.querySelector('.wmd-slab-tile__caption');

    if (!caption) {
      caption = document.createElement('span');
      caption.className = 'wmd-slab-tile__caption';
      caption.innerHTML =
        '<span class="wmd-slab-tile__name"></span><span class="wmd-slab-tile__price"></span>';
      tile.el.appendChild(caption);
    }

    var nameEl = caption.querySelector('.wmd-slab-tile__name');
    var priceEl = caption.querySelector('.wmd-slab-tile__price');

    if (nameEl.textContent !== name) nameEl.textContent = name;
    if (priceEl.textContent !== price) priceEl.textContent = price;

    var selected = !!(tile.input && tile.input.checked);
    tile.el.classList.toggle('is-selected', selected);

    return selected;
  }

  function ensureNote(grid, cfg) {
    var holder = grid.parentElement;
    if (!holder || !cfg.note) return;
    if (holder.querySelector('.wmd-slab-note')) return;

    var p = document.createElement('p');
    p.className = 'wmd-slab-note';
    p.textContent = cfg.note;
    holder.appendChild(p);
  }

  function setLabel(button, cfg, hiddenCount, expanded) {
    var text = expanded ? cfg.less : String(cfg.more).replace('{n}', String(hiddenCount));
    if (button.textContent !== text) button.textContent = text;
  }

  function updateChosen(root, cfg, selectedTile) {
    var form = root.querySelector('product-form');
    if (!form || !form.parentElement) return;

    var box = root.querySelector('.wmd-chosen');

    if (!selectedTile) {
      if (box) box.remove();
      return;
    }

    if (!box) {
      box = document.createElement('div');
      box.className = 'wmd-chosen';
      box.innerHTML =
        '<img class="wmd-chosen__thumb" alt="" width="52" height="40">' +
        '<span class="wmd-chosen__text">' +
        '<span class="wmd-chosen__label"></span>' +
        '<span class="wmd-chosen__value"></span>' +
        '</span>';
      form.parentElement.insertBefore(box, form);
    }

    var img = box.querySelector('.wmd-chosen__thumb');
    var srcImg = selectedTile.el.querySelector('img');
    var src = srcImg ? srcImg.getAttribute('src') || srcImg.currentSrc || srcImg.src : '';

    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);

    var labelEl = box.querySelector('.wmd-chosen__label');
    var valueEl = box.querySelector('.wmd-chosen__value');
    var label = cfg.chosen || '';
    var value = tileName(selectedTile);

    if (labelEl.textContent !== label) labelEl.textContent = label;
    if (valueEl.textContent !== value) valueEl.textContent = value;
  }

  function applySlabs(root, cfg) {
    var grid = findGrid(root, cfg.optionNames);
    if (!grid) return;

    grid.classList.add('wmd-slab-grid');

    if (!grid.id) {
      seq += 1;
      grid.id = 'wmd-slab-grid-' + seq;
    }

    ensureNote(grid, cfg);

    var tiles = collectTiles(grid);
    var total = tiles.length;
    var cap = visibleCap();
    var holder = grid.parentElement;
    var button = holder ? holder.querySelector('.wmd-slab-toggle') : null;

    var selectedTile = null;
    var selectedIndex = -1;

    for (var i = 0; i < total; i++) {
      if (decorate(tiles[i], cfg)) {
        selectedTile = tiles[i];
        selectedIndex = i;
      }
    }

    /* Collapse and the toggle come BEFORE the chosen-slab box on purpose: if anything
       ever throws while building that box, the expander must still exist. */
    if (total <= cap) {
      for (var j = 0; j < total; j++) {
        tiles[j].el.classList.remove('wmd-slab-tile--hidden');
      }
      if (button) button.remove();
    } else {
      var wasExpanded = button ? button.getAttribute('aria-expanded') === 'true' : false;
      var expanded = wasExpanded || selectedIndex >= cap;

      for (var k = 0; k < total; k++) {
        tiles[k].el.classList.toggle('wmd-slab-tile--hidden', !expanded && k >= cap);
      }

      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'wmd-slab-toggle';
        button.setAttribute('aria-controls', grid.id);

        button.addEventListener('click', function () {
          var isOpen = button.getAttribute('aria-expanded') !== 'true';
          var current = collectTiles(grid);
          var currentCap = visibleCap();

          for (var n = 0; n < current.length; n++) {
            current[n].el.classList.toggle('wmd-slab-tile--hidden', !isOpen && n >= currentCap);
          }

          button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          setLabel(button, cfg, current.length - currentCap, isOpen);
        });

        grid.insertAdjacentElement('afterend', button);
      }

      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      setLabel(button, cfg, total - cap, expanded);
    }

    try {
      updateChosen(root, cfg, selectedTile);
    } catch (e) {
      /* Never let the confirmation box take the picker down with it. */
    }
  }

  function syncLegSelection(box) {
    var labels = box.querySelectorAll('.wmd-leg-option');

    for (var i = 0; i < labels.length; i++) {
      var input = labels[i].querySelector('input[name="wmd_leg_choice"]');
      if (input && input.checked) {
        labels[i].classList.add('wmd-leg-option--selected');
      } else {
        labels[i].classList.remove('wmd-leg-option--selected');
      }
    }
  }

  function applyLegs(root, cfg) {
    if (!cfg.legs) return;

    var box = root.querySelector('.wmd-leg-options');
    if (!box || box.dataset.wmdLegsDone === '1') return;

    var fieldset = box.closest('fieldset');

    if (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend && cfg.legs.title) legend.textContent = cfg.legs.title;

      var note = fieldset.querySelector('p');
      if (note && cfg.legs.note) {
        note.textContent = cfg.legs.note;
        note.classList.add('wmd-legs__note');
      }
    }

    box.classList.add('wmd-legs-grid');

    var labels = box.querySelectorAll('label');

    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var input = label.querySelector('input[name="wmd_leg_choice"]');
      if (!input) continue;

      var spec = cfg.legs[input.value];
      if (!spec) continue;

      label.classList.add('wmd-leg-option');
      label.removeAttribute('style');
      label.textContent = '';

      if (spec.img) {
        var img = document.createElement('img');
        img.className = 'wmd-leg-thumb';
        img.src = spec.img;
        img.alt = spec.label;
        img.loading = 'lazy';
        img.width = 600;
        img.height = 450;
        label.appendChild(img);
      }

      var row = document.createElement('span');
      row.className = 'wmd-leg-option__row';
      row.appendChild(input);

      var name = document.createElement('span');
      name.textContent = spec.label;
      row.appendChild(name);

      if (spec.price) {
        var price = document.createElement('span');
        price.className = 'wmd-leg-option__price';
        price.textContent = spec.price;
        row.appendChild(price);
      }

      label.appendChild(row);
    }

    box.dataset.wmdLegsDone = '1';
    syncLegSelection(box);

    box.addEventListener('change', function () {
      syncLegSelection(box);
    });
  }

  function run() {
    if (busy) return;
    busy = true;
    suppress = true;

    try {
      var cfg = config();
      if (!cfg) return;

      var scopes = document.querySelectorAll('.product-info');

      if (scopes.length) {
        for (var i = 0; i < scopes.length; i++) {
          applySlabs(scopes[i], cfg);
          applyLegs(scopes[i], cfg);
        }
      } else {
        applySlabs(document, cfg);
        applyLegs(document, cfg);
      }
    } finally {
      busy = false;
      window.requestAnimationFrame(function () {
        suppress = false;
      });
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      run();
    });
  }

  function init() {
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', schedule);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.name && event.target.name.indexOf('-option') !== -1) {
      schedule();
      window.setTimeout(schedule, 250);
      window.setTimeout(schedule, 900);
    }
  });

  window.addEventListener('resize', schedule);

  new MutationObserver(function () {
    if (suppress) return;
    schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
